import CreateDataRetrievalBegunAction from "./CreateDataRetrievalBegunAction";
import CreateDataRetrievalEndedAction from "./CreateDataRetrievalEndedAction";

import { GET } from "../adapters/xhr";

export default function (licenceApplicationId) {
    return (dispatch) => {
        dispatch(CreateDataRetrievalBegunAction());

        const url = "api/Vessel/getByLicenceApplicationId?licenceApplicationId="+licenceApplicationId;
        
        GET(url)
            .then(function (response) {
                if (response.status === 200) {
                    dispatch({
                        type: "VESSEL_RETRIEVED",
                        vessel: response.data
                    });
                }

                dispatch(CreateDataRetrievalEndedAction());
            }).catch(function (response) {
                dispatch(CreateDataRetrievalEndedAction());
            });
    };
}
